import AppShell from '@/app/AppShell';
import { AuthProvider } from '@/features/auth/AuthContext';
import { LocaleProvider } from '@/i18n/LocaleProvider';

function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
